// extracted by mini-css-extract-plugin
export default {"navbar":"navbar_navbar__pxttL","main-heading":"navbar_main-heading__Qdjg2","subheading":"navbar_subheading__AaoD+"};